import { Raycaster } from 'three'
import Experience from '../Experience.js'
import HeroWall from "./HeroWall.js";
import FluidCursor from "../FluidCursor/FluidCursor";
import Background from "./Background";
import IntroUI from "../UI/IntroUI";
// import HeroTitle from "./HeroTitle.js";

export default class World {
    constructor() {
        this.experience = new Experience()
        this.ui = this.experience.ui
        this.time = this.experience.time

        this.camera = this.experience.camera;
        this.scene = this.experience.scene

        this.resources = this.experience.resources
        this.input = this.experience.input
        this.fluidCursor = new FluidCursor()
        this.fluidCursorTexture = this.fluidCursor.getTexture()
        this.raycaster = new Raycaster();
        this.setupWorld()
    }

    setupHero() {
        this.heroWall = new HeroWall(this.fluidCursorTexture)
        // this.heroTitle = new HeroTitle()
    }

    setupContentBackground() {
        this.backgroundEl = document.getElementById('cyber60-content-background')
        this.background = new Background(this.backgroundEl);
    }


    setupWorld() {
        this.setupContentBackground()
        this.setupHero()
        this.setupIntroUI()
        this.experience.appLoaded = true
    }

    setupIntroUI() {
        this.introUI = new IntroUI()
    }


    resize() {
        if(this.fluidCursor) {
            this.fluidCursor.resize()
        }

        if(this.heroWall) {
            this.heroWall.resize()
        }
    }

    update( deltaTime ) {
        if(this.camera && this.heroWall) {
            this.raycaster.setFromCamera(this.input.cursor, this.camera.instance);
        }

        this.heroWall?.update( deltaTime )
        // this.heroTitle?.update( deltaTime )
        this.background?.render( deltaTime )
        this.fluidCursor.update( deltaTime )
    }

    destroy() {
        this.heroWall?.destroy()
        this.fluidCursor.destroy()
        this.background.destroy()
    }
}
